import * as constants from '../../constants';

const validations = [
    {
        field: 'name',
        method: 'isEmpty',
        validWhen: false,
        message: 'Name is required.'
    },
    {
        field: 'ruleTypeId',
        method: 'isEmpty',
        validWhen: false,
        message: 'Rule Type is required.'
    },
    {
        field: 'franchises',
        method: 'isEmpty',
        validWhen: false,
        message: 'Instances are Required.'
    },
    // Escalation validation
    {
        field: 'escalationTypeId',
        method: 'custom',
        fn: (_value, state) => {
            const typeId = parseInt(state.escalationTypeId || 0);
            const EscalationType = constants.EscalationTypeEnum || {};
            return !isNaN(typeId) && (typeId === EscalationType.Monthly || typeId === EscalationType.Yearly || typeId === EscalationType.Never);
        },
        validWhen: true,
        message: 'Escalation Type is required.'
    },
    // Escalations (Never): require single positive amount
    {
        field: 'escalations',
        method: 'custom',
        fn: (_value, state) => {
            const typeId = parseInt(state.escalationTypeId || 0);
            if (typeId !== constants.EscalationTypeEnum.Never) return true; // Not applicable
            const escalationsRows = Array.isArray(state.escalations) ? state.escalations : [];
            if (escalationsRows.length !== 1) { return false; }
            const amount = parseFloat(escalationsRows[0]?.amount);
            return !isNaN(amount) && amount > 0;
        },
        validWhen: true,
        message: 'Amount is required and must be greater than 0.'
    },
    // Escalations (Monthly/Yearly): contiguous, non-overlapping ranges with positive amounts
    {
        field: 'escalations',
        method: 'custom',
        fn: (_value, state) => {
            const typeId = parseInt(state.escalationTypeId || 0);
            if (!(typeId === constants.EscalationTypeEnum.Monthly || typeId === constants.EscalationTypeEnum.Yearly)) return true; // Not applicable
            const escalationsRows = Array.isArray(state.escalations) ? state.escalations : [];
            if (escalationsRows.length === 0) { return false; }
            const normalizedRows = escalationsRows.map(row => ({
                from: parseInt(row.from),
                to: parseInt(row.to),
                amount: parseFloat(row.amount)
            }));
            for (let i = 0; i < normalizedRows.length; i++) {
                const row = normalizedRows[i];
                if (isNaN(row.from) || isNaN(row.to) || isNaN(row.amount)) { return false; }
                // First row may start at 0; others must be >=1
                if (i === 0) {
                    if (row.from !== 0) { return false; }
                } else if (row.from < 1) { return false; }
                if (row.to < 1) { return false; }
                if (row.from > row.to) { return false; }
                // Amount: first row can be 0; others must be >0
                if (i === 0) {
                    if (row.amount < 0) { return false; }
                } else if (row.amount <= 0) { return false; }
            }
            normalizedRows.sort((a, b) => a.from - b.from);
            let expectedNextFrom = 0;
            for (const row of normalizedRows) {
                if (row.from !== expectedNextFrom) { return false; }
                expectedNextFrom = row.to + 1;
            }
            return true;
        },
        validWhen: true,
        message: 'Provide valid, contiguous escalation ranges starting at 0 (warning) then 1+, with allowed first amount 0 and subsequent amounts > 0.'
    },
    // Filter groups: if a group is added it must have at least one selected value
    {
        field: 'filterGroups',
        method: 'custom',
        fn: (_value, state) => {
            const groups = Array.isArray(state.filterGroups) ? state.filterGroups : [];
            if (groups.length === 0) { return true; } // No groups added -> valid
            return groups.every(g => Array.isArray(g.values) && g.values.length > 0 && g.values.every(v => v && typeof v === 'object' && v.value !== undefined && v.value !== null && v.value !== ''));
        },
        validWhen: true,
        message: 'Each added filter requires at least one selected value.'
    }
];

export default validations;
